export enum CarTypeLabel {
  'covered-hopper' = 'Covered Hopper',
  'pressure-tank' = 'Pressure Tank',
  'general-service' = 'General Service Tank',
  'gondola' = 'Gondola',
  'open-hopper' = 'Open Hoppers',
}

export enum CarTypeDropdownLabel {
  'covered-hopper' = 'Covered Hopper',
  'pressure-tank' = 'Pressure Tank Car',
  'general-service' = 'General Service Tank Car',
  'gondola' = 'Gondola',
  'open-hopper' = 'Open Hoppers',
}

export enum STCCCarType {
  'Covered Hopper' = 'covered-hopper',
  'Pressure Tank' = 'pressure-tank',
  'General Service Tank' = 'general-service',
  'Gondola' = 'gondola',
  'Open Hoppers' = 'open-hopper',
}

export enum CountryCode {
  'USA' = 'US',
  'Canada' = 'CA',
  'Mexico' = 'MX',
}

export enum CAR_TYPE {
  COVERED_HOPPER = 'covered-hopper',
  PRESSURE_TANK = 'pressure-tank',
  GENERAL_SERVICE = 'general-service',
  GONDOLA = 'gondola',
  OPEN_HOPPER = 'open-hopper',
}
